import React, { useContext, useState } from 'react';
import { AccommodationContext } from '../context/AccommodationContext';
import AddSingleAmenity from './AddSingleAmenity';
import Swal from 'sweetalert2';
import { AuthContext } from '../context/AuthContext';
import { uploadImage } from '../images/ImageUploader';

export default function UpdateAmenities({ accommodation, setEditAmenities }) {
  const { updateAmenity, deleteAmenity } = useContext(AccommodationContext);
  const { currentUser } = useContext(AuthContext);
  const [addAmenity, setAddAmenity] = useState(false);
  const [updatedAmenities, setUpdatedAmenities] = useState(
    accommodation?.amenities.map(amenity => ({
      newImage: amenity.image,
      newImageId: amenity.image_id,
      newAmenity: amenity.amenity,
      error: ''
    }))
  );

  // Function to validate the amenity
  const validateAmenity = (newAmenity, currentIndex) => {
    return accommodation?.amenities.some((amenity, index) =>
      index !== currentIndex && amenity.amenity.toLowerCase() === newAmenity.toLowerCase()
    )
      ? 'This amenity already exists.'
      : '';
  };

  // Handle caption change with real-time validation
  const handleCaptionChange = (event, index) => {
    const newAmenity = event.target.value;
    setUpdatedAmenities(prevState => {
      const updated = [...prevState];
      updated[index].newAmenity = newAmenity;
      updated[index].error = validateAmenity(newAmenity, index);
      return updated;
    });
  };

  const handleImageChange = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      setUpdatedAmenities(prevState => {
        const updated = [...prevState];
        updated[index].newImage = file;
        return updated;
      });
    }
  };

  const handleUpdate = async (event, id, index) => {
    event.preventDefault();
    const { newAmenity, newImage, newImageId, error } = updatedAmenities[index];
    
    // Validate before proceeding with the update
    if (error) {
      Swal.fire({
        text: "Please correct the errors before submitting.",
        showConfirmButton: false,
        timer: 4000,
        icon: 'warning',
        color: 'white',
        background: 'orange',
        toast: true,
        position: 'top'
      });
      return;
    }

    const formData = new FormData();
    formData.append('amenity', newAmenity);
    
    try {
      let imageUrl, imageId;

      if (newImage instanceof File) {
        const result = await uploadImage(newImage);
        imageUrl = result.url;
        imageId = result.id;
      } else {
        imageUrl = newImage;
        imageId = newImageId;
      }

      formData.append('image', imageUrl);
      formData.append('image_id', imageId);
      
      updateAmenity(id, formData);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  function handleDelete(id) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      height: 50
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAmenity(id);
      }
    });
  }

  return (
    <div className="container-fluid col-md-6 pt-2">
      <h3 className="text-center mb-4" style={{ fontFamily: 'inknut antiqua', color: 'wheat', position: 'relative' }}>
        Update Amenities
        <button
          className="btn btn-success text-white"
          onClick={() => setAddAmenity(true)}
          style={{ position: 'absolute', top: '50%', right: '20%', transform: 'translateY(-50%)', cursor: 'pointer' }}
        >
          +
        </button>
        <button
          className="btn btn-danger text-white"
          onClick={() => setEditAmenities(false)}
          style={{ position: 'absolute', top: '50%', right: '10%', transform: 'translateY(-50%)', cursor: 'pointer' }}
        >
          ×
        </button>
      </h3>
      {addAmenity ? (
        <AddSingleAmenity accommodation={accommodation} setAddAmenity={setAddAmenity} />
      ) : (
        <div className="row row-cols-1 g-4">
          {accommodation?.amenities.map((amenity, index) => (
            <div key={index} className="col">
              <details className='rounded px-2' style={{ backgroundColor: 'rgb(175, 238, 238,0.8)' }}>
                <summary className='d-flex justify-content-between align-items-center'>
                  <p className="mt-1 text-center text-dark">{amenity.amenity}</p>
                  {currentUser && currentUser?.position === 'ADMIN' && (
                    <button
                      onClick={() => handleDelete(amenity.id)}
                      className='btn btn-sm btn-danger align-self-end mb-1'
                    >
                      Delete
                    </button>
                  )}
                </summary>
                <form onSubmit={(event) => handleUpdate(event, amenity.id, index)}>
                  <div className="mb-3">
                    <label htmlFor={`newImage-${index}`} className="form-label">New Image</label>
                    <input
                      type="file"
                      className="form-control"
                      id={`newImage-${index}`}
                      accept=".png, .jpg, .jpeg"
                      onChange={(event) => handleImageChange(event, index)}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor={`newAmenity-${index}`} className="form-label">Amenity</label>
                    <input
                      type="text"
                      className="form-control"
                      id={`newAmenity-${index}`}
                      value={updatedAmenities[index].newAmenity}
                      onChange={(event) => handleCaptionChange(event, index)}
                    />
                    {updatedAmenities[index].error && (
                      <div className="text-danger">{updatedAmenities[index].error}</div>
                    )}
                  </div>
                  <button type="submit" className="btn btn-primary" disabled={!!updatedAmenities[index].error}>
                    Submit
                  </button>
                </form>
              </details>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
